import { render, staticRenderFns } from "./priceSharpness.vue?vue&type=template&id=ea3510c4&scoped=true"
import script from "./priceSharpness.vue?vue&type=script&lang=js"
export * from "./priceSharpness.vue?vue&type=script&lang=js"
import style0 from "./priceSharpness.vue?vue&type=style&index=0&id=ea3510c4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3510c4",
  null
  
)

export default component.exports